export default __webpack_public_path__ + "static/media/banner1.ab70e3d2.png";